const Periods = {
  NOW: 'now',
  MINUTE: 'minute',
  HOUR: 'hour',
  DAY: 'day',
  MONTH: 'month',
  YEAR: 'year',
  OVERALL: 'overall',
};

export default Periods;
